export default __webpack_public_path__ + "static/media/admin.7ae3442c.png";